/**
 * @flow
 * Created by neo on 12.07.17.
 */
import { observable, action } from 'mobx';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
const de = require('./de.json');
const fr = require('./fr.json');
const it = require('./it.json');
const en = require('./en.json');

export class LanguageStoreClass {
  i18n = i18n;
  @observable lang: string = 'en';

  constructor() {
    i18n
    // .use(XHR)
    .use(LanguageDetector)
    .init({
      nsSeparator: false,
      keySeparator: false, // so we can use . in keys

      fallbackLng: 'en',
      debug: true,

      interpolation: {
        escapeValue: false, // not needed for react!!
      },

      detection: {
        order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
        lookupQuerystring: 'lang',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',

        // cache user language on
        caches: ['localStorage', 'cookie'],
        excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
      },

      load: 'languageOnly',

      // react i18next special options (optional)
      react: {
        wait: false, // set to true if you like to wait for loaded in every translated hoc
        nsMode: 'default' // set it to fallback to let passed namespaces to translated hoc act as fallbacks
      },

      resources: {
        de: {
          translation: de
        },
        en: {
          translation: en
        },
        fr: {
          translation: fr
        },
        it: {
          translation: it
        }
      }
    });

    this.lang = i18n.language;
  }

  @action setLang(lang: string) {
    i18n.changeLanguage(lang);
    this.lang = lang;
  }
}

const LanguageStore = new LanguageStoreClass();
export default LanguageStore;



// WEBPACK FOOTER //
// ./src/lang/index.js